"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PORTAL: 'portalTz',
  USER: 'userTz',
  UTC: 'utc'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/constants/TimezoneTypes.js
// module id = 381
// module chunks = 209 210 211 212